import { Wrap } from './styles';

import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
/**
 * Itemlist
 * 
 * @param {boolean} checked
 * @param {string} label
 * @param {string} type
 * @param {String} name 
 * @param {Number} index 
 * @param {boolean} onChange
 * @param {Number} value Number
 * @param {*} props Resto
 * 
 * @returns 
 */
const ItemList = ({
  checked,
  label,
  type,
  name,
  index,
  onChange,
  value,
  ...props
}) => {
  return (
    <Wrap>
      <label htmlFor={`${name}-${index}`}>{label}</label>
      {type === 'checkbox' ? (
        <Checkbox
          id={`${name}-${index}`}
          checked={checked}
          onChange={onChange}
          value={value}
          size="small"
        />
      ) : (
        <Radio
          id={`${name}-${index}`}
          checked={checked}
          onChange={onChange}
          value={value}
          size="small"
        />
      )}
    </Wrap>
  );
};

export default ItemList;
